import { MULTI_FIELD_KEY_SEPARATOR } from 'c-main/Components/Campaign/CampaignReports/ElasticSearch/Transformers';

/**
 * Splits a multi group-by row key (`48 Sheets | JCDecaux | 1235161785`) into one cell per grouping
 * column. A blank value keeps its column and stays blank; the display count goes after the first
 * column's value either way, so a row with a blank first value still shows it.
 */
export const multiFieldLabels = (
    composite: string,
    labels: string[],
    displayCount: number,
): Record<string, string> => {
    const parts = composite.split(MULTI_FIELD_KEY_SEPARATOR);
    const countSuffix =
        Number.isFinite(displayCount) && displayCount > 0
            ? ` (${Math.round(displayCount).toLocaleString()})`
            : '';
    return labels.reduce<Record<string, string>>((acc, label, i) => {
        const v = parts[i] ?? '';
        acc[label] = i === 0 ? `${v}${countSuffix}`.trim() : v;
        return acc;
    }, {});
};
